<template>
  <TopBar />
  <section id="breadcrumbs" class="breadcrumbs">
    <div class="container">
      <div class="col-lg-12">
      <ol>
        <li><a href="/">Início</a></li>
        <li><a href="sou-lojista">Sou Lojista</a></li>
      </ol>
      <h2>Marque uma Reunião</h2>
      </div>
    </div>
  </section>
  <!-- End Breadcrumbs -->

  <section class="inner-page mt-5">
    <div class="container">
      <h4 class="classic-title">
        <span style="border-bottom: 1px solid red">Insira os dados</span>
      </h4>
      <div class="col-lg-12">
        <div class="row">

            <div class="row">
              <div class="form-group mt-3">
                <input v-model="nome" type="text" name="name" class="form-control" id="name" placeholder="Nome" required/>
              </div>
            </div>
            <div class="form-group mt-3">
              <input v-model="email" type="email" class="form-control" name="email" id="email" placeholder="E-mail" required/>
              <br />
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <input v-model="telefone" type="text" name="telefone" class="form-control" id="telefone" placeholder="Telefone" required/>
              </div>
              <div class="col-md-6 form-group mt-3 mt-md-0">
                <input v-model="celular" type="text" class="form-control" name="celular" id="celular" placeholder="Celular" required/>
                <br />
              </div>
            </div>

              <div class="row">
              <div class="col-md-3">
                <select v-model="uf" @change="onChange($event)" class="form-select" aria-label="Default select example">
                  <option selected>Estados</option>
                  <option value="PR">PR</option>
                  <option value="SC">SC</option>
                  <option value="RS">RS</option>
                  <option value="SP">SP</option>
                  <option value="RJ">RJ</option>
                  <option value="MG">MG</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MT">MT</option>
                  <option value="MS">MS</option>
                  <option value="TO">TO</option>
                  <option value="BA">BA</option>
                  <option value="SE">SE</option>
                  <option value="AL">AL</option>
                  <option value="PE">PE</option>
                  <option value="PB">PB</option>
                  <option value="RN">RN</option>
                  <option value="CE">CE</option>
                  <option value="PI">PI</option>
                  <option value="MA">MA</option>
                  <option value="PA">PA</option>
                  <option value="AM">AM</option>
                  <option value="AP">AP</option>
                  <option value="RR">RR</option>
                  <option value="AC">AC</option>
                  <option value="RN">RN</option>
                  <option value="DF">DF</option>
                </select>
                <br />
              </div>

              <div class="col-md-9">
                <select v-if="info" v-model="cidade" class="form-select" aria-label="Default select example">
                  <option v-for="nome in this.info.data.CIDADES" :key="nome">{{nome.nome}}</option>
                </select>
                 <select v-else class="form-select" aria-label="Default select example">
                  <option selected>Cidade</option>
                </select>
                <br />
              </div>
            </div>

            <div class="form-group mt-3">
              <input v-model="motivo" type="text" class="form-control" name="motivo" id="motivo" placeholder="Motivo da Reunião" required/>
              <br />
            </div>

            <div class="form-group mt-3">
              <textarea v-model="mensagem" class="form-control" name="message" rows="5" placeholder="Observações" required></textarea>
              <br />
            </div>
            <div class="text-center mb-5">
              <button v-on:click="salvar" class="btn btn-danger" style="border-radius: 0px;">Enviar</button>
            </div>

        </div>
      </div>
    </div>
  </section>
  <Footer />
</template>

<script>
import Footer from "../components/Footer.vue";
import TopBar from "../components/TopBar.vue";
import axios from 'axios';
import Swal from 'sweetalert2'

export default {
  name: "MarcarReuniao",
  components: {
    TopBar,
    Footer,
  },
  data(){
    return{
      nome:null,
      email:null,
      telefone:null,
      celular:null,
      motivo:null,
      mensagem:null,
      uf:null,
      cidade:null,
      info:null
    }
  },
    methods:{
   onChange(val){
     console.log(val)
      axios
        .get(`https://siscredit.com.br/siscred/retorna_cidade_json.php?estado=${val.target.value}`)
        .then(res => (this.info = res))
        console.log(this.info)

    },
    salvar(){

       if(!this.nome||!this.telefone||!this.email||!this.celular||!this.uf||!this.cidade||!this.motivo){
          Swal.fire(
              `Ops!`,
              `Preencha os campos`,
              `error`
               )
      }else{

      axios
        .post(`https://siscredit.com.br/siscred/web_rest.php?email_reuniao=true&nome=${this.nome}&email=${this.email}&telefone=${this.telefone}&celular=${this.celular}&mensagem=${this.mensagem}&motivo=${this.motivo}&uf=${this.uf}&cidade=${this.cidade}`)
        .then(resp =>

            console.log(resp),
              Swal.fire(
              `Email Enviado!`,
              `Aguarde nosso retorno`,
              `success`
               )
            )

        .catch(err =>
            Swal.fire(
              `Email não Enviado!`,
              `erro interno ${err}`,
              `error`
               )
        )
      }

    },


  }
}
</script>

<style scoped>
.breadcrumbs {
  padding: 45px 0;
  margin-top: 4rem;
  background: #efefef;
}
@media only screen and (max-width: 320px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

@media only screen and (min-width: 321px) and (max-width: 768px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}


.breadcrumbs h2 {
  font-size: 26px;
  font-weight: 600;
}
.breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 0 10px 0;
  margin: 0;
  font-size: 14px;
}
.breadcrumbs ol li + li {
  padding-left: 10px;
}
.breadcrumbs ol li + li::before {
  display: inline-block;
  padding-right: 10px;
  color: #333333;
  content: "/";
}
</style>
